import { lazyLoad } from "utils/loadable"

export const HubManagementPage = lazyLoad(
  () => import("./index"),
  module => module.HubManagementPage,
)
